export default "__VITE_ASSET__CWpZekqo__"